import { render } from "./Contattaci.vue?vue&type=template&id=d0d37f5c&scoped=true"
import script from "./Contattaci.vue?vue&type=script&lang=js"
export * from "./Contattaci.vue?vue&type=script&lang=js"

import "./Contattaci.vue?vue&type=style&index=0&id=d0d37f5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0d37f5c"]])

export default __exports__